// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"c5cde7f3","51":"4d3efd58","116":"7399ebd9","351":"8a4ef70a","523":"0eb7e892","555":"aa1b747c","779":"91a76299"}[chunkId] + ".chunk.css";
};